import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectProspect = state => {
    return selectOwnState(state).prospect
}

export const selectMedicalCondition = state => {
    const prospect = selectProspect(state)
    return prospect ? prospect.medicalCondition : null
}

export const selectTreatmentExpectation = state => {
    const prospect = selectProspect(state)
    return prospect ? prospect.treatmentExpectation : null
}

export const selectProspectId = state => {
    const prospect = selectProspect(state)
    return prospect ? prospect.id : null
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}



// WEBPACK FOOTER //
// ./src/modules/prospect/state/detail/selector.js